<template>
  <screen-time :child-id="id" />
</template>

<script>
  import ScreenTime from '@/components/Child/ChildTabs/TabScreenTime/ScreenTime.vue'

  export default {
    props: {
      id: {
        required: true
      }
    },

    components: {
      ScreenTime
    }
  }
</script> 
